import * as React from 'react';
import axios from 'axios';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import {destURL,createUserData} from './../utils/Utils'

import PreloaderAnim from './PreloaderAnim'
import RegelsKlassement from './RegelsKlassement'
import CountdownTuesday from './CountdownTuesday'


export default function HomeComponent() {
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [year, setYear] = React.useState("");
  const [regels, setRegels] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
//    let u = destURL + "?test=1"
    let u = destURL + "?"+window._currentYear+"=1"
    if(window.location.href.indexOf("dinsdaghakkers") > -1 )u = destURL + "?"+window._currentYear+"=1"
    axios.get(u)
      .then(res => {
        let uData = createUserData(res.data)
//        console.log(uData)
        let arr = []
        let a = Object.keys(uData)
        for(let i=0;i<a.length;i++) {
          let u = uData[a[i]]
          let score = u.getMeanScore(5)
          let games = Math.min(u.getTimesPlayed(), 5)
          let birds = u.getBirdies()
          let name = u.getName()
          arr.push({name:name,score:score,games:games,birds:birds})
        }
        // Sort by score (highest first), if equal or zero sort by last name
        arr.sort((a,b) => {
          const scoreA = parseFloat(a.score) || 0
          const scoreB = parseFloat(b.score) || 0
          if (scoreA === scoreB || (scoreA === 0 && scoreB === 0)) {
            // Sort by last name (alphabetically)
            const lastNameA = a.name.split(' ').pop().toLowerCase()
            const lastNameB = b.name.split(' ').pop().toLowerCase()
            return lastNameA.localeCompare(lastNameB)
          }
          return scoreB - scoreA
        })
        setRegels(arr)
        setLoading(false)
      })
      .catch(err => {
        console.error('Fout bij ophalen data:', err)
        setError('Kon de data niet ophalen. Controleer je internetverbinding of probeer het later opnieuw.')
        setLoading(false)
      })
  },[]);

  const config = window._dailyConfig || {};

  return (
    <>
        <Toolbar />
        <CountdownTuesday />
        {config.welcomeMessage && (
          <p style={{margin: '0 0 10px 0', color: '#666', fontStyle: 'italic'}}>
            {config.welcomeMessage}
          </p>
        )}
        <h1 style={{margin:0}}>Klassement {year}</h1>
        {loading && <PreloaderAnim />}
        {error && (
          <div style={{padding: '20px', backgroundColor: '#ffebee', borderRadius: '8px', color: '#c62828', marginTop: '20px'}}>
            <strong>Fout:</strong> {error}
          </div>
        )}
        {!loading && !error && regels.map((item, i) => {
          return <RegelsKlassement key={i} index={i} medal={i+1} caption={item.name} count={item.score} games={item.games} />
         })}

        {config.weatherTip && (
          <div style={{
            marginTop: '20px',
            padding: '12px 15px',
            background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)',
            borderRadius: '8px',
            borderLeft: '4px solid #1976D2',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span style={{fontSize: '24px'}}>🌤️</span>
            <span style={{color: '#1565C0', fontSize: '14px'}}>{config.weatherTip}</span>
          </div>
        )}

        {(config.jokeOfDay || config.tipOfDay) && (
          <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
            {config.jokeOfDay && (
              <p style={{margin: '0 0 10px 0'}}>
                <strong>😄 Grap van de dag:</strong> {config.jokeOfDay}
              </p>
            )}
            {config.tipOfDay && (
              <p style={{margin: 0}}>
                <strong>⛳ Tip van de dag:</strong> {config.tipOfDay}
              </p>
            )}
          </div>
        )}
    </>
  );
}